module.exports = __webpack_public_path__ + "static/media/about_placeholder.d533f8b4.png";